import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../lib/api'
import { getToken, setToken, getAdmin, setAdmin, clearAuth } from '../lib/auth'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(getToken())
  const admin = ref(getAdmin())

  const isAuthenticated = computed(() => !!token.value)
  const adminName = computed(() => admin.value?.name || '')
  const adminId = computed(() => admin.value?.id || null)
  const role = computed(() => admin.value?.role || null)
  const isRoot = computed(() => role.value === 'ROOT')
  const isAdmin = computed(() => role.value === 'ADMIN')
  const isCheckin = computed(() => role.value === 'CHECKIN')
  const isOrganizador = computed(() => role.value === 'ORGANIZADOR')
  const canShowCheckin = computed(() => isRoot.value || isAdmin.value || isCheckin.value)
  const canManageAdmins = computed(() => isRoot.value || isAdmin.value)
  const canManageEventos = computed(() => isRoot.value || isAdmin.value)
  const canManageRepasses = computed(() => isRoot.value || isAdmin.value)
  const canSeeFinanceiroCompleto = computed(() => isRoot.value || isAdmin.value)
  const canSeeFinanceiro = computed(() => isRoot.value || isAdmin.value || isOrganizador.value)
  // Mesmos papeis de canSeeFinanceiro, com nome proprio: a exportacao nao e
  // sobre dado financeiro, e juntar os dois deixaria a proxima mudanca numa
  // regra mexer sem querer na outra.
  const canExportarLista = computed(() => isRoot.value || isAdmin.value || isOrganizador.value)

  async function login(email, password) {
    const { data } = await api.post('/auth/login', { email, password })
    token.value = data.token
    admin.value = data.admin
    setToken(data.token)
    setAdmin(data.admin)
    return data
  }

  async function refresh() {
    try {
      const { data } = await api.get('/auth/me')
      admin.value = data.admin
      setAdmin(data.admin)
    } catch {}
  }

  function logout() {
    token.value = null
    admin.value = null
    clearAuth()
  }

  return {
    token, admin, role,
    isAuthenticated, adminName, adminId,
    isRoot, isAdmin, isCheckin, isOrganizador,
    canManageAdmins, canManageEventos, canManageRepasses, canShowCheckin,
    canSeeFinanceiro, canSeeFinanceiroCompleto, canExportarLista,
    login, logout, refresh
  }
})
